export default __webpack_public_path__ + "static/medical-history-form-SDA-9fd530a2f14c90994a6175e5e84e46f0.pdf";